// Allow-list of "actionable" elements that should make a click sound. Plain
// text, inputs/typing, scroll areas and the bare score canvas are intentionally
// excluded — only deliberate UI actions click.
const INTERACTIVE_SELECTOR = [
  'button',
  'a[href]',
  '[role="button"]',
  'ion-button',
  'ion-back-button',
  'ion-fab-button',
  'ion-item[button]',
  'ion-toggle',
  'ion-checkbox',
  'ion-radio',
  'ion-segment-button',
  'ion-select',
  'ion-tab-button',
].join(',');

// Skip disabled/locked controls, and anything opted out explicitly (e.g. the
// settings preview button, which plays its own sound). NOTE: `.is-inactive` is
// deliberately NOT excluded — gameplay toggle tiles (lines/spaces, icons) wear
// it as their "currently off" visual state while staying fully clickable, so
// excluding it would mute the very press that turns them on. Genuinely disabled
// tiles carry `aria-disabled` instead.
const EXCLUDE_SELECTOR =
  '[disabled],[aria-disabled="true"],.is-locked,.button-disabled,[data-no-click-sound]';

/**
 * Resolve the nearest actionable ancestor of an event target (or null). Used by
 * the global click-sound listener so a single delegated handler covers the app.
 */
export function clickSoundTarget(start: EventTarget | null): Element | null {
  if (!(start instanceof Element)) return null;
  const el = start.closest(INTERACTIVE_SELECTOR);
  if (!el) return null;
  if (el.closest(EXCLUDE_SELECTOR)) return null;
  return el;
}
